import { withTranslation } from "react-i18next";

import TicketAssignConfigList from './TicketAssignConfigList';

export default withTranslation(undefined, { withRef: true })(TicketAssignConfigList);